export const DEFAULT_DATES = [
  { value: "2023-01-01,2023-01-31", label: "JAN-23" },
  { value: "2023-02-01,2023-02-28", label: "FEB-23" },
  { value: "2023-03-01,2023-03-31", label: "MAR-23" },
  { value: "2023-04-01,2023-04-30", label: "APR-23" },
  { value: "2023-05-01,2023-05-31", label: "MAY-23" },
  { value: "2023-06-01,2023-06-30", label: "JUN-23" },
  { value: "2023-07-01,2023-07-31", label: "JUL-23" },
  { value: "2023-08-01,2023-08-31", label: "AUG-23" },
  { value: "2023-09-01,2023-09-30", label: "SEP-23" },
  { value: "2023-10-01,2023-10-31", label: "OCT-23" },
  { value: "2023-11-01,2023-11-30", label: "NOV-23" },
  { value: "2023-12-01,2023-12-31", label: "DEC-23" },
  { value: "2024-01-01,2024-01-31", label: "JAN-24" },
  { value: "2024-02-01,2024-02-29", label: "FEB-24" }, // Leap year
  { value: "2024-03-01,2024-03-31", label: "MAR-24" },
  { value: "2024-04-01,2024-04-30", label: "APR-24" },
  { value: "2024-05-01,2024-05-31", label: "MAY-24" },
  { value: "2024-06-01,2024-06-30", label: "JUN-24" },
  { value: "2024-07-01,2024-07-31", label: "JUL-24" },
  { value: "2024-08-01,2024-08-31", label: "AUG-24" },
  { value: "2024-09-01,2024-09-30", label: "SEP-24" },
  { value: "2024-10-01,2024-10-31", label: "OCT-24" },
  { value: "2024-11-01,2024-11-30", label: "NOV-24" },
  { value: "2024-12-01,2024-12-31", label: "DEC-24" },
  { value: "2025-01-01,2025-01-31", label: "JAN-25" },
  { value: "2025-02-01,2025-02-28", label: "FEB-25" },
  { value: "2025-03-01,2025-03-31", label: "MAR-25" },
  { value: "2025-04-01,2025-04-30", label: "APR-25" },
  { value: "2025-05-01,2025-05-31", label: "MAY-25" },
  { value: "2025-06-01,2025-06-30", label: "JUN-25" },
  { value: "2025-07-01,2025-07-31", label: "JUL-25" },
  { value: "2025-08-01,2025-08-31", label: "AUG-25" },
  { value: "2025-09-01,2025-09-30", label: "SEP-25" },
  { value: "2025-10-01,2025-10-31", label: "OCT-25" },
  { value: "2025-11-01,2025-11-30", label: "NOV-25" },
  { value: "2025-12-01,2025-12-31", label: "DEC-25" },
  { value: "2026-01-01,2026-01-31", label: "JAN-26" },
].reverse();

// Years array (2023-2025)
export const DEFAULT_YEARS = [
  { value: "2023-01-01,2023-12-31", label: "2023" },
  { value: "2024-01-01,2024-12-31", label: "2024" },
  { value: "2025-01-01,2025-12-31", label: "2025" },
  { value: "2026-01-01,2026-12-31", label: "2026" },
].reverse();

// Quarters array
export const DEFAULT_QUARTERS = [
  // 2023
  { value: "2023-01-01,2023-03-31", label: "Q1-2023" },
  { value: "2023-04-01,2023-06-30", label: "Q2-2023" },
  { value: "2023-07-01,2023-09-30", label: "Q3-2023" },
  { value: "2023-10-01,2023-12-31", label: "Q4-2023" },
  // 2024
  { value: "2024-01-01,2024-03-31", label: "Q1-2024" },
  { value: "2024-04-01,2024-06-30", label: "Q2-2024" },
  { value: "2024-07-01,2024-09-30", label: "Q3-2024" },
  { value: "2024-10-01,2024-12-31", label: "Q4-2024" },
  // 2025
  { value: "2025-01-01,2025-03-31", label: "Q1-2025" },
  { value: "2025-04-01,2025-06-30", label: "Q2-2025" },
  { value: "2025-07-01,2025-09-30", label: "Q3-2025" },
  { value: "2025-10-01,2025-12-31", label: "Q4-2025" },
  // 2026
  { value: "2026-01-01,2026-03-31", label: "Q1-2026" },
  { value: "2026-04-01,2026-06-30", label: "Q2-2026" },
  { value: "2026-07-01,2026-09-30", label: "Q3-2026" },
  { value: "2026-10-01,2026-12-31", label: "Q4-2026" },
].reverse();

// Financial Years array (Apr-Mar)
export const DEFAULT_FINANCIAL_YEARS = [
  { value: "2022-04-01,2023-03-31", label: "FY 2022-23" },
  { value: "2023-04-01,2024-03-31", label: "FY 2023-24" },
  { value: "2024-04-01,2025-03-31", label: "FY 2024-25" },
  { value: "2025-04-01,2026-03-31", label: "FY 2025-26" },
  { value: "2026-04-01,2027-03-31", label: "FY 2026-27" },
].reverse();

// Helper function to calculate time periods
export const calculateTimePeriods = (dateString: string) => {
  if (!dateString) return { year: "", quarter: "", financialYear: "" };

  const dateObj = new Date(dateString);
  const year = dateObj.getFullYear();
  const month = dateObj.getMonth(); // 0-11

  // Calculate quarter (Q1-Q4)
  const quarter = `Q${Math.floor(month / 3) + 1}-${year}`;

  // Calculate financial year (Apr-Mar)
  // If month is Apr-Mar (3-11), then FYxx-yy, else FY(xx-1)-xx
  const financialYear =
    month >= 3
      ? `FY${year}-${(year + 1).toString().slice(-2)}`
      : `FY${year - 1}-${year.toString().slice(-2)}`;

  return {
    year: year.toString(),
    quarter,
    financialYear,
  };
};

export const FilteredOutEntity = [
  "CREPLB_BIOMASS Intrastate",
  "JGPEPLB_BIOMASS Intrastate",
  "JUWMJL WTE BIOMASS Intrastate",
  "KTS POWERS BIOMASS Intrastate",
  "KTA POWERS BIOMASS Intrastate",
  "SAEPL BIOMASS Intrastate",
  "Mahi Intrastate",
  "RPS Intrastate",
  "JSHYDRO Intrastate",
];

export function generateDateRanges(
  startYear: number = 2019
): { value: string; label: string }[] {
  const dateRanges: { value: string; label: string }[] = [];

  // Get current date for the end range
  const currentDate = new Date();
  const endYear = currentDate.getFullYear();
  const endMonth = currentDate.getMonth(); // 0-indexed (0 = January)

  // Loop through years
  for (let year = startYear; year <= endYear; year++) {
    // Loop through months (0-11)
    const monthLimit = year === endYear ? endMonth : 11;

    for (let month = 0; month <= monthLimit; month++) {
      // Format month as 2 digits (01, 02, etc.)
      const monthStr = (month + 1).toString().padStart(2, "0");

      // Get the last day of the month (accounting for leap years)
      const lastDay = new Date(year, month + 1, 0).getDate();
      const lastDayStr = lastDay.toString().padStart(2, "0");

      // Create start and end date strings
      const startDate = `${year}-${monthStr}-01`;
      const endDate = `${year}-${monthStr}-${lastDayStr}`;

      // Create month abbreviation (JAN, FEB, etc.)
      const monthAbbr = new Date(year, month)
        .toLocaleString("default", { month: "short" })
        .toUpperCase();

      // Format the year as 2 digits (19, 20, etc.)
      const yearShort = year.toString().slice(-2);

      // Add to array
      dateRanges.push({
        value: `${startDate},${endDate}`,
        label: `${monthAbbr}-${yearShort}`,
      });
    }
  }

  // Reverse so most recent dates are first
  return dateRanges.reverse();
}

// Usage:
// export const DEFAULT_DATES = generateDateRanges();

export const GROUP_BY = ["state"];
export const DEMAND_UNITS = ["MW", "MWh"];

export const DataTabs = [
  { label: "Chart", value: "chart" },
  { label: "Summary", value: "summary" },
  { label: "Table", value: "table" },
];
